import { Component } from '@angular/core';

@Component({
  selector: 'hfc-field-error',
  templateUrl: './field-error.component.html',
  styleUrls: ['./field-error.component.scss']
})
export class FieldErrorComponent {}
